module.exports = __webpack_public_path__ + "static/media/ic_more.0f08f2b3.svg";